import React from 'react';
import { ApolloProvider, ApolloConsumer } from '@apollo/react-hooks';
import { TastingKitModal } from '@onehope/ohw-pages-home';
import { client } from '../../../../monorepo/apollo/client';
import { urlProductCatalogPage } from '../../../../server/utils/routeConstants';

const TastingKitModalOHW = ({ user }) => {
  return (
    <>
      <ApolloProvider client={client}>
        <ApolloConsumer>
          {apolloClient => (
            <TastingKitModal
              user={user}
              apolloClient={apolloClient}
              redirectUrl={urlProductCatalogPage}
            />
          )}
        </ApolloConsumer>
      </ApolloProvider>
    </>
  );
};

export default TastingKitModalOHW;
